module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "textcenter"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _c('a', {
    attrs: {
      "id": "ch00_fm03"
    }
  }), _c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("PREVIOUS WORKS BY THE AUTHOR")])]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_c('em', [_vm._v("Black Mesa Poems")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter1"
  }, [_c('em', [_vm._v("Martin & Meditations on the South Valley")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter1"
  }, [_c('em', [_vm._v("Immigrants in Our Own Land and Selected Early Poems")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter1"
  }, [_c('em', [_vm._v("Working in the Dark: Reflections of a Poet of the Barrio")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-567a8fe2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm03.vue
// module id = 63
// module chunks = 0